import { compose, withStateHandlers } from 'recompose';
import Immutable from 'seamless-immutable';

import { withProfile } from './queries';

const INITIAL_STATE = Immutable({
  profileMenuOpen: false,
});

export const enhance = compose(
  withProfile(),
  withStateHandlers(INITIAL_STATE, {
    handleProfileClick:
      ({ profileMenuOpen }) =>
      () => ({
        profileMenuOpen: !profileMenuOpen,
      }),
    handleMenuClose: () => () => ({ profileMenuOpen: false }),
  })
);
